const textFieldModalEquipServiceGroup = {
  name: 'Nome da Seção'
};

export default textFieldModalEquipServiceGroup;
